import { ROLE_OPTIONS } from "../utils/roles";

// Checkbox list for picking one or more dashboard roles.
function RolesCheckboxes({ selected, onChange }) {
  const toggle = (value) => {
    onChange(
      selected.includes(value)
        ? selected.filter((role) => role !== value)
        : [...selected, value]
    );
  };

  return (
    <div className="flex flex-wrap gap-3">
      {ROLE_OPTIONS.map((option) => {
        const checked = selected.includes(option.value);
        return (
          <label
            key={option.value}
            htmlFor={`role-${option.value}`}
            className={`cursor-pointer w-[170px] rounded-lg border px-3 py-2 ${
              checked ? "border-[#0388CC] bg-[#E9F6FD]" : "border-[#c4c8cf]"
            }`}
          >
            <div className="flex items-center text-[14px] text-[#000]">
              <input
                id={`role-${option.value}`}
                type="checkbox"
                className="mr-2 rounded"
                checked={checked}
                onChange={() => toggle(option.value)}
              />
              <span
                className="mr-2 inline-block h-[10px] w-[10px] rounded-full"
                style={{ backgroundColor: option.color }}
              />
              {option.label}
            </div>
            <div className="font-[400] text-[12px] mt-1 text-[red]">
              {option.description}
            </div>
          </label>
        );
      })}
    </div>
  );
}

export default RolesCheckboxes;
